// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @bitwarden/platform/no-enums
export enum StorageLocation {
  Both = "both",
  Disk = "disk",
  Memory = "memory",
}
